export class WayToPayImportModel {
  counter: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  enterpriseId: number = 0;
  consecutiveCashReceipt: number = 0;
  isChargeAccount: boolean = false;
  wayToPayCode: number = 0;
  valueWayToPay: number = 0;
  constructor(
    counter: number,
    companyId: number,
    branchId: number,
    enterpriseId: number,
    consecutiveCashReceipt: number,
    isChargeAccount: boolean,
    wayToPayCode: number,
    valueWayToPay: number,
  ) {
    this.counter = counter;
    this.companyId = companyId;
    this.branchId = branchId;
    this.enterpriseId = enterpriseId;
    this.consecutiveCashReceipt = consecutiveCashReceipt;
    this.isChargeAccount = isChargeAccount;
    this.wayToPayCode = wayToPayCode;
    this.valueWayToPay = valueWayToPay;
  }
}